import { ReactComponent as JUG } from "../../customIcons/Jug.svg";
import { ReactComponent as D30 } from "../../customIcons/Drum30.svg";
import { ReactComponent as D55 } from "../../customIcons/Drum55.svg";
import { ReactComponent as TOTE } from "../../customIcons/Tote.svg";
import { ReactComponent as PFC } from "../../customIcons/PFC.svg";
import { ReactComponent as TON } from "../../customIcons/Ton.svg";
import { ReactComponent as B50 } from "../../customIcons/Bag50.svg";
import { ReactComponent as B40 } from "../../customIcons/Bag40.svg";
import { ReactComponent as B30 } from "../../customIcons/Bag30.svg";
import { ReactComponent as B25 } from "../../customIcons/Bag25.svg";
import { ReactComponent as TR } from "../../customIcons/ToteRefill.svg";
import { ReactComponent as GAL } from "../../customIcons/GAL.svg";
import { ReactComponent as LBS } from "../../customIcons/LBS.svg";
import { ReactComponent as GALJUG } from "../../customIcons/GalJug.svg";
import { ReactComponent as PAIL } from "../../customIcons/Pail.svg";

import { ReactComponent as AREA } from "../../customIcons/Acerage.svg";
import { ReactComponent as LIME } from "../../customIcons/LIME.svg";


import {useEffect, useState} from "react";

const UMIcons = ({ selectedVolume, size, color }) => {
    
    const [SelectedComponent, setSelectedComponent] = useState(null); // This will store the component itself
    const sharedClassName = `${size ? `${size}` : 'size-8'} ${color ? `${color}` : 'text-green-600'}`; // You can also move this to Tailwind config if reused widely

    
    useEffect(() => {
        const volumeMap = {
            "2.5": { component: JUG },
            "30": { component: D30 },
            "55": { component: D55 },
            "275": { component: TOTE },
            "TR": { component: TR },
            "GAL": { component: GAL },
            "B50": { component: B50 },
            "B40": { component: B40 },
            "B30": { component: B30 },
            "B25": { component: B25 },
            "LB": { component: LBS },
            "TON": { component: TON },
            "CS4": { component: GALJUG },
            "PAI": { component: PAIL },
          
            "0.25ACR": { component: AREA },
            "0.5ACR": { component: AREA },
            "0.75ACR": { component: AREA },
            "1ACR": { component: AREA },
            "1.25ACR": { component: AREA },
            "1.5ACR": { component: AREA },
            "2ACR": { component: AREA },
          
        };
    
      const volumeData = volumeMap[selectedVolume];
    
      if (volumeData) {
        setSelectedComponent(volumeData.component);
      } else {
        setSelectedComponent(PFC);
      }
      
    }, [selectedVolume]);
    

    return (
        <div className={`w-fit h-fit`}>

            {SelectedComponent ? (
              <SelectedComponent className={sharedClassName} />
            ) : (
              <PFC className={sharedClassName} />
            )}

            
        </div>
    )
}

export default UMIcons;
